export default __webpack_public_path__ + "static/summer_containers81-0071a25972ad8e9ceb9f8daf0405c5e4.webp";